// A helper function that finds one resource object in an array or resource objects
// Essentially it can find one resource in src/pages/resources
// To use it, pass it an object with three properties:
// resourceName -> the title of the resource you want to find
// onlyGetUrl -> a boolean, that tells the function to only return a url string instead of an object
// resourcesArray -> an array of resource objects you are search through

export default function findResource(object) {
  if (!object || typeof object !== 'object') {
    throw new Error(
      'Expected an object with resourceName, onlyGetUrl, and resources properties.'
    );
  }

  const { resourceName, onlyGetUrl, resources } = object;

  if (!resourceName || typeof resourceName !== 'string') {
    throw new Error('resourceName should be a non-empty string.');
  }

  if (typeof onlyGetUrl !== 'boolean') {
    throw new Error('onlyGetUrl should be a boolean.');
  }

  if (!Array.isArray(resources)) {
    throw new Error('resources should be an array of resource objects.');
  }

  // Find the resource object by comparing the inputted name to the resource's title
  const resourceObj = resources.find(
    resource =>
      resource.node.frontmatter.title.toLowerCase().trim() ===
      resourceName.toLowerCase().trim()
  );

  if (!resourceObj) {
    throw new Error(`Resource with name "${resourceName}" not found.`);
  }

  const { frontmatter } = resourceObj.node;

  // If the url is the only thing needed, return either the gated content url or the file url
  if (onlyGetUrl) {
    return frontmatter.gatedContentURL || frontmatter.file.publicURL;
  }

  // Return an object with all of the resource's information needed to build the UI
  const resource = {
    ...frontmatter,
    file: frontmatter.file.publicURL,
    gatedContentURL: frontmatter.gatedContentURL,
    thumbnail: frontmatter.thumbnail.childCloudinaryAsset,
  };

  return resource;
}
